// Must byte-match the server tool NAME (create_dataset.py) — the name is the
// single contract between server advertisement and browser dispatch.
export const CREATE_DATASET_TOOL_NAME = "create_dataset";
